// Brand-specific utilities based on URL parameter with orga/ prefix
export const getBrandConfig = () => {
  // Extraire l'organizationId du paramètre d'URL avec format /orga/:organizationId
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  // Format attendu: /orga/:organizationId
  // pathSegments = ['orga', 'organizationId', ...]
  let organizationId = "";

  if (pathSegments.length >= 2 && pathSegments[0] === "orga") {
    organizationId = pathSegments[1] || "";
  }

  return {
    organizationId,
    logoPath: organizationId ? `../assets/logo-${organizationId}.png` : "../assets/logo.png",
  };
};

// Get the correct organization ID for orders
export const getOrganizationId = (): string => {
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);

  let organizationId = "";

  if (pathSegments.length >= 2 && pathSegments[0] === "orga") {
    organizationId = pathSegments[1] || "";
  }

  return organizationId;
};

// Helper pour construire les URLs avec organizationId et préfixe orga/
export const buildUrlWithOrg = (
  path: string,
  organizationId?: string,
): string => {
  const orgId = organizationId || getOrganizationId();
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `/orga/${orgId}${cleanPath}`;
};

// Get the correct logo path
export const getLogoPath = (): string => {
  return getBrandConfig().logoPath;
};
